import React, { useState } from 'react';
import {FaTimes} from 'react-icons/fa';
import Swal from 'sweetalert2';
import styles from '../Preguntas/AnadirPregunta.module.css'; 
import { useAuth } from '../../../Auth/AuthContext';

const AñadirResultados = ({
    testId,
    isOpen,
    onClose,
    onSuccess,
    getMaxOrden
}) => {
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});
    const [nuevoArea, setNuevoArea] = useState({
        ar_codigo: '',
        ar_nombre: '',
        ar_descripcion: '',
        ar_orden: 0
    });

    const {getToken} = useAuth(); 
    const token = getToken(); 

    React.useEffect(() => {
        if (isOpen) {
            setNuevoArea({
                ar_codigo: '',
                ar_nombre: '',
                ar_descripcion: '',
                ar_orden: getMaxOrden() + 1
            });
            setErrors({});
        }
    }, [isOpen, getMaxOrden]);

    const handleInputChange = (field, value) => {
        setNuevoArea(prev => ({
            ...prev,
            [field]: value
        }));
        
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!nuevoArea.ar_codigo.trim()) {
            newErrors.ar_codigo = 'El código es obligatorio';
        }

        if (!nuevoArea.ar_nombre.trim()) {
            newErrors.ar_nombre = 'El nombre es obligatorio';
        }

        if (nuevoArea.ar_orden && nuevoArea.ar_orden < 1) {
            newErrors.ar_orden = 'El orden debe ser mayor a 0';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {
        if (!validateForm()) {
            return;
        }

        try {
            setSaving(true);

            const areaData = {
                ar_test_clave: testId,
                ar_codigo: nuevoArea.ar_codigo.trim().toUpperCase(),
                ar_nombre: nuevoArea.ar_nombre.trim(),
                ar_descripcion: nuevoArea.ar_descripcion.trim(),
                ar_orden: nuevoArea.ar_orden || getMaxOrden() + 1
            };


            const response = await fetch(`${process.env.REACT_APP_API_URL}/test/areas/crear-area`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(areaData)
            });

            if (response.ok) {
                await Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'El área se ha creado correctamente',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#242b57', 
                    customClass: { 
                        popup: 'popupbonito', 
                    }
                });

                onSuccess();
                onClose();
            } else {
                let errorTitle = 'Error';
                let errorMessage = 'No se pudo crear el área';

                try {
                    const errorData = await response.json();

                    if (errorData.error && errorData.message) {
                        errorTitle = errorData.error;
                        errorMessage = errorData.message;
                    } else if (errorData.message) {
                        errorMessage = errorData.message;
                    }

                    switch (response.status) {
                        case 400:
                            if (errorMessage.includes('campos obligatorios')) {
                                errorTitle = 'Campos obligatorios';
                            } else if (errorMessage.includes('ID de test inválido')) {
                                errorTitle = 'Test inválido';
                            } else if (errorMessage.includes('Código inválido')) {
                                errorTitle = 'Código inválido';
                            } else if (errorMessage.includes('Código duplicado')) {
                                errorTitle = 'Código duplicado';
                            } else if (errorMessage.includes('Test no válido')) {
                                errorTitle = 'Test no válido';
                            } else if (errorMessage.includes('Datos duplicados')) {
                                errorTitle = 'Datos duplicados';
                            }
                            break;
                        case 404:
                            errorTitle = 'Test no encontrado';
                            break;
                        case 500:
                            errorTitle = 'Error del servidor';
                            break;
                    }

                } catch (parseError) {
                    console.warn('No se pudo parsear el error del backend:', parseError);
                    errorMessage = `Error ${response.status}: ${response.statusText}`;
                }

                await Swal.fire({
                    icon: 'error',
                    title: errorTitle,
                    text: errorMessage,
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#242b57', 
                    customClass: { 
                        popup: 'popupbonito', 
                    }
                });
            }
        } catch (error) {
            console.error('Error al crear área:', error);

            await Swal.fire({
                icon: 'error',
                title: 'Error de conexión',
                text: 'No se pudo conectar con el servidor. Verifique su conexión a internet.',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#242b57', 
                customClass: { 
                    popup: 'popupbonito', 
                },
            });
        } finally {
            setSaving(false);
        }
    };

    const handleCancel = () => {
        setNuevoArea({
            ar_codigo: '',
            ar_nombre: '',
            ar_descripcion: '',
            ar_orden: 0
        });
        setErrors({});
        onClose();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleCancel();
        }
    };

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay} onClick={handleOverlayClick}>
            <div className={styles.modalContainer}>
                <div className={styles.modalHeader}>
                    <h2>
                        Nueva Área de Resultado
                    </h2>
                    <button
                        className={styles.modalCloseBtn}
                        onClick={handleCancel}
                        disabled={saving}
                    >
                        <FaTimes />
                    </button>
                </div>

                <div className={styles.modalContent}>
                    <div className={styles.preguntaForm}>
                        <div className={styles.preguntaFormGroupWide}>
                                <label>
                                    Código 
                                </label>
                                <input
                                    type="text"
                                    className={styles.inputForm}
                                    value={nuevoArea.ar_codigo}
                                    onChange={(e) => handleInputChange('ar_codigo', e.target.value.slice(0, 2))}
                                    placeholder="IM, LM"
                                    maxLength="2"
                                    style={{ textTransform: 'uppercase' }}
                                />
                                {errors.ar_codigo && (
                                    <span className={styles.errorText}>{errors.ar_codigo}</span>
                                )}
                        </div>

                        <div className={styles.preguntaFormGroup}>
                            <label>
                                Orden
                            </label>
                                <input
                                    type="number"
                                    className={styles.inputForm}
                                    value={nuevoArea.ar_orden}
                                    onChange={(e) => handleInputChange('ar_orden', parseInt(e.target.value))}
                                    min="1"
                                />
                                {errors.ar_orden && <span className={styles.errorText}>{errors.ar_orden}</span>}
                        </div>

                        <div className={styles.preguntaFormGroup}>
                            <label>
                                Nombre del Área 
                            </label>
                            <input
                                type="text"
                                className={styles.inputForm}
                                value={nuevoArea.ar_nombre}
                                onChange={(e) => handleInputChange('ar_nombre', e.target.value)}
                                placeholder="Ej: Inteligencia emocional"
                                />
                                {errors.ar_nombre && <span className={styles.errorText}>{errors.ar_nombre}</span>}
                            </div>

                        <div className={styles.preguntaFormGroup}>
                            <label>
                                Descripción
                            </label>
                            <input
                                className={styles.inputForm}
                                value={nuevoArea.ar_descripcion}
                                onChange={(e) => handleInputChange('ar_descripcion', e.target.value)}
                                placeholder="Descripción del área"
                                rows="2"
                                />
                        </div>
                        </div>
                </div>

                <div className={styles.modalFooter}>
                    <div className={styles.preguntaFormActions}>
                        <button
                            className={styles.btnSave}
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? (
                                <>
                                <div className={styles.btnSpinner}></div>
                                Guardando...
                                </>
                            ) : (
                                <>
                                Crear Área
                                </>
                        )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AñadirResultados;